<template>
  <div class="type-dropdown">
    <PillDropdown
      :name="$t('search.typeDropdownName')"
      :allow-multi-select="true"
      :options="typesState"
      :has-search-results="hasSearchResults"
      @clear-filters="clearFilters"
      @apply-filters="applyFilters"
      @filter-applied="$emit('filterApplied', $event)"
    >
    </PillDropdown>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useSearchFilters } from '@/composables/useSearchFilters';
import PillDropdown from './PillDropdown.vue';

defineEmits(['filterApplied']);
defineProps({
  hasSearchResults: {
    type: Boolean,
    default: false,
  },
});
const { $t } = useNuxtApp();
const route = useRoute();
const { typesState, initializeTypes, selectedTypes } = useSearchFilters();

// Initialize types when component mounts
onMounted(() => {
  const allTypes = [
    { name: $t('search.events.tagName'), type: 'events', idx: 0, checked: false },
    { name: $t('search.documents.tagName'), type: 'assets', idx: 1, checked: false },
    { name: $t('search.athletics.tagName'), type: 'athletics', idx: 2, checked: false },
    { name: $t('search.staff.tagName'), type: 'staff', idx: 3, checked: false },
    { name: $t('search.forms.tagName'), type: 'forms', idx: 4, checked: false },
    { name: $t('search.liveFeed.tagName'), type: 'live_feeds', idx: 5, checked: false },
    { name: $t('search.articles.tagName'), type: 'news', idx: 6, checked: false },
    { name: $t('search.links.tagName'), type: 'links', idx: 7, checked: false },
    { name: $t('search.pages.tagName'), type: 'pages', idx: 8, checked: false },
  ];
  initializeTypes(allTypes);
});

function clearFilters() {
  const newQuery = { ...route.query };
  delete newQuery.query_indices;
  navigateTo({ query: newQuery }, { replace: true });
}

function applyFilters() {
  const newQuery = { ...route.query, query_indices: selectedTypes.value };
  navigateTo({ query: newQuery }, { replace: true });
}
</script>
